<template>
    <div class="thumbnail">
        <div class="thumbnail-image"
                v-if="data !== false"
                @click="setImage(data,data.pos)"
                v-bind:style="{ backgroundImage: 'url(' + data.image + ')' }"></div>
        <!-- <img v-if="data !== false" :src="data.image" alt=""> -->
    </div>
</template>

<script>

import Router from 'vue-router'
import {store} from '../store';

export default {
  name: 'Thumbnail',
  props: ['data','isDownloadable','position'],
  methods: {
    setImage(obj,pos) {
      this.$store.dispatch('updateSelectedImage',[obj,pos]);
    }
  }
}
</script>

<style scoped lang="scss">

.thumbnail-image {
    width: 100%;
    height: 150px;
    background-position: center;
    background-size: cover;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);
    transition: box-shadow 150ms ease-out;
    &:hover {
        box-shadow: 0px 10px 23px -10px rgba(0, 0, 0, 0.5);
        transition: box-shadow 150ms ease-out;
    }
}

.thumbnail {
  width: 50%;
  float: left;
  padding: 10px;
  cursor: pointer;
}



.thumbnail img{
    float: left;
    width: 100%;
}

.image-title,
.document-number {
  font-size: 13px;
  margin-bottom: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/Thumbnail.vue